<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import type { SearchFilterConfig } from "module/store/Filters";

  import FilterModal from "./FilterModal.svelte";
  import FilterOptionSausage from "./FilterOptionSausage.svelte";
  import { getSubTypes, typeLabel } from "module/typeUtils";
  import type { DocumentType } from "module/foundryDocuments";

  let {
    open = false,
    config,
    thisType,
  }: {
    open?: boolean;
    config: SearchFilterConfig;
    thisType: "Actor" | "Item";
  } = $props();

  const dispatch = createEventDispatcher();

  const subTypes = getSubTypes(thisType);

  let types = $derived(new Set(config.documentTypes));
  let mainSelected = $derived(types.has(thisType));

  function toggleAll() {
    let updated = new Set(types);
    if (types.has(thisType)) {
      updated.delete(thisType);
    } else {
      const other = config.documentTypes.filter(
        (t) => t.split(":")[0] !== thisType,
      );
      updated = new Set(other);
      updated.add(thisType);
    }

    dispatch("change", { documentTypes: Array.from(updated) });
  }

  function selectSubType(subType: string) {
    const updated = new Set(types);

    if (types.has(thisType)) {
      updated.delete(thisType);
    }
    if (types.has(subType)) {
      updated.delete(subType);
    } else {
      updated.add(subType);
    }

    dispatch("change", { documentTypes: Array.from(updated) });
  }

  function clear() {
    const other = config.documentTypes.filter(
      (t) => t.split(":")[0] !== thisType,
    );

    dispatch("change", { documentTypes: other });
  }
</script>

<FilterModal title={typeLabel(thisType)} {open} on:close on:clear={clear}>
  <ul>
    <FilterOptionSausage
      selected={mainSelected}
      title={typeLabel(thisType)}
      square
      on:click={toggleAll}
    />
    {#each subTypes as subType}
      <FilterOptionSausage
        selected={mainSelected || types.has(subType)}
        title={typeLabel(subType)}
        square
        on:click={() => selectSubType(subType)}
      />
    {/each}
  </ul>
</FilterModal>

<style>
  ul {
    overflow: auto;
    padding: 0;
    flex-grow: 1;
    margin: 0;
  }

  ul :global(li:not(:first-child)) {
    margin-left: 10px;
  }
</style>
